import {JournalEntryItemApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";

export default class JournalEntryItem {

	constructor(public readonly accountId: string,
		public readonly credit: Option<number>,
		public readonly debit: Option<number>) {}

	static fromJson(json: JournalEntryItemApiDto): JournalEntryItem {
		return new JournalEntryItem(json.accountId, option(json.credit), option(json.debit));
	}

	static compare = (a: JournalEntryItem, b: JournalEntryItem, accountAName: string, accountBName: string): number => {
		if (a.credit.isDefined && b.credit.isEmpty) {
			return -1;
		}
		if (a.debit.isDefined && b.debit.isEmpty) {
			return 1;
		}
		const accountNameCompareResult = accountAName.localeCompare(accountBName);
		return accountNameCompareResult === 0 ? a.accountId.localeCompare(b.accountId) : accountNameCompareResult;
	};
}
